import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { Navbar } from '../components/ui/Navbar';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';

import { LoginPage } from '../components/pages/LoginPage';
import { HomePage } from '../components/pages/HomePage';
import { UploadPage } from '../components/pages/UploadPage';
import { NotFoundPage } from '../components/codes/NotFoundPage';
import { AcusePage } from '../components/pages/AcusePage';
import { PricePage } from '../components/pages/PricePage';
import { PriceIdPage } from '../components/pages/PriceIdPage';

export const AppRouter = () => {

    //<Router basename={'proveedores'}>
    //<Router>

    return (
        <Router basename={'/proveedores'}>
            <div>
                <Navbar />
                <div className="container"> 
                    <Switch>
                        <PublicRoute exact path={"/login"} component={ LoginPage } />
                        <PrivateRoute exact path={"/upload"} component={ UploadPage } />
                        <PrivateRoute exact path={"/acuse/:folio"} component={ AcusePage } />
                        <PrivateRoute exact path={"/acuse"} component={ AcusePage } />
                        <PrivateRoute exact path={"/price"} component={ PricePage } />
                        <PrivateRoute exact path={"/price/:folio"} component={ PriceIdPage } />
                        <PrivateRoute exact path={"/"} component={ HomePage } />
                        <Route path="*" component={ NotFoundPage } />
                    </Switch>
                </div>
            </div>
        </Router>
    )
}